import React from 'react';

import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseOutlined,
} from '@ant-design/icons';

import {
  ArrowButton,
  CloseButton,
  MediaWrapper,
  ModalContent,
  ModalOverlay,
  NavigationWrapper,
} from './styles';

interface LightboxProps {
  mediaUrl: string;
  isVideo: boolean;
  onClose: () => void;
  onNext: () => void;
  onPrevious: () => void;
  totalMediaCount: number;
}

const Lightbox: React.FC<LightboxProps> = ({
  mediaUrl,
  isVideo,
  onClose,
  onNext,
  onPrevious,
  totalMediaCount,
}) => {
  return (
    <ModalOverlay>
      <CloseButton onClick={onClose}>
        <CloseOutlined />
      </CloseButton>
      <ModalContent>
        <NavigationWrapper>
          {totalMediaCount > 1 && (
            <>
              <ArrowButton onClick={onPrevious}>
                <ArrowLeftOutlined />
              </ArrowButton>
            </>
          )}

          <MediaWrapper>
            {isVideo ? (
              <video
                controls
                src={mediaUrl}
                style={{ width: '100%', height: '100%' }}
              />
            ) : (
              <img
                src={mediaUrl}
                alt="Media"
                style={{ width: '100%', height: '100%' }}
              />
            )}
          </MediaWrapper>

          {totalMediaCount > 1 && (
            <>
              <ArrowButton onClick={onNext}>
                <ArrowRightOutlined />
              </ArrowButton>
            </>
          )}
        </NavigationWrapper>
      </ModalContent>
    </ModalOverlay>
  );
};

export default Lightbox;
